import { styled, css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledTooltipWrapper = styled(Flex)`
    align-items: center;
    padding: 16px;
    column-gap: 8px;

    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;

export const StyledPoint = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    ${({ color }) => css`
        background-color: ${color};
    `};
    flex-shrink: 0;
`;
